import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';

export type RunKind = 'MANUAL' | 'AUTOMATED';

const I18N_LABEL: Record<RunKind, string> = {
  MANUAL: 'testRun.art.MANUAL',
  AUTOMATED: 'testRun.art.AUTOMATED',
};

const I18N_TITLE: Record<RunKind, string> = {
  MANUAL: 'testRun.art.MANUALTitle',
  AUTOMATED: 'testRun.art.AUTOMATEDTitle',
};

const ICON: Record<RunKind, string> = {
  MANUAL: 'manage_accounts',
  AUTOMATED: 'settings',
};

/**
 * Art eines Testlaufs — manuell oder automatisiert.
 */
@Component({
  selector: 'app-art-pill',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [TranslatePipe],
  template: `
    <span class="art-pill" [attr.data-art]="art()" [attr.data-testid]="testId()" [attr.title]="titleKey() | translate">
      <span class="art-pill__icon material-icons" aria-hidden="true">{{ icon() }}</span>
      {{ labelKey() | translate }}
    </span>
  `,
  styles: `
    :host {
      display: inline-flex;
    }

    .art-pill {
      display: inline-flex;
      align-items: center;
      gap: 0.375rem;
      padding: 0.1875rem 0.625rem;
      border-radius: 0.375rem;
      font-size: 0.6875rem;
      font-weight: 600;
      white-space: nowrap;
      background: #ffffff;
      color: var(--to-text);
      border: 1px solid #99d6ea;

      &[data-art='AUTOMATED'] {
        border-color: var(--to-brand-border);

        .art-pill__icon {
          color: var(--to-brand-bright);
        }
      }

      &[data-art='MANUAL'] {
        border-color: #99d6ea;

        .art-pill__icon {
          color: var(--to-info-fg);
        }
      }
    }

    .art-pill__icon {
      font-size: 0.75rem;
      width: 0.75rem;
      height: 0.75rem;
    }
  `,
})
export class ArtPillComponent {
  readonly art = input.required<RunKind>();

  readonly icon = computed(() => ICON[this.art()]);
  readonly testId = computed(() => `art-pill-${this.art().toLowerCase()}`);
  readonly labelKey = computed(() => I18N_LABEL[this.art()]);
  readonly titleKey = computed(() => I18N_TITLE[this.art()]);
}
